module.exports = __webpack_public_path__ + "static/media/failure-high.0bb309f7.0bb309f7.svg";